import { PropsWithChildren } from "react"
import { ThemeProvider } from '@mui/material/styles';
import { SISDefaultTheme, SisLibraryProviders } from "@sis/react-library";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "../../utils/msalInstance";
import { StompSessionProvider } from "react-stomp-hooks";

export const ProjectProviders = ({
    children
}: PropsWithChildren) => {

    const theme = SISDefaultTheme;

    return (
        <MsalProvider instance={msalInstance}>
            <ThemeProvider theme={theme}>
                <SisLibraryProviders theme={theme}>
                    <StompSessionProvider url={globalThis.config.websocket_url}>
                        {children}
                    </StompSessionProvider>
                </SisLibraryProviders>
            </ThemeProvider>
        </MsalProvider>
    )
}
